<template>
    <div class="tabcontent">
        <v-container :fluid="true" v-resize="onResize" ref="bddsplancontainer">
            <v-row align="center">
                <v-col cols="12" md="1" sm="2">
                    <v-select
                            v-model="yearbdds"
                            :items="yearfilter"
                            label="Год"
                            @input="changeYearHandle"
                    ></v-select>
                </v-col>
                <!--
                <v-col cols="12" md="2" sm="2">
                  <v-select
                      multiple
                      v-model="monthbdds"
                      :items="monthsFilter"
                      label="Месяц"
                      @input="changeYearHandle"
                  ></v-select>
                </v-col>
                -->
                <v-col cols="12" md="3" sm="6">
                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                        <v-select
                                v-model="IdOrg"
                                :items="orglist"
                                label="Организация"
                                @input="changeOrg"
                        ></v-select>
                    </v-skeleton-loader>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                        <v-select
                                v-model="IdHouse"
                                :items="houselist"
                                label="Объект"
                                @input="changeHouse"
                        ></v-select>
                    </v-skeleton-loader>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                    <v-switch
                            v-model="switchTarif"
                            label="Тариф"
                            @change="switchTarifClick"
                            :disabled="IdHouse < 1"
                            class="float-left"
                    ></v-switch>
                    <v-btn color="primary" @click="updateClick()" class="ml-2 mt-3">
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="addStaii" class="ml-2 mt-3" :disabled="this.IdOrg <= 0">Добавить</v-btn>
                    <v-btn color="primary" class="ml-2 mt-3" @click="excelPlanList" dark>
                      <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-skeleton-loader
                :loading="loading"
                type="table-tbody"
                class="mx-auto"
        >
        <v-card>
            <v-simple-table>
                <template>
                    <thead>
                    <tr>
                        <th class="stick sticky-header" style="min-width: 280px;">Статья оборота</th>
                        <th class="sticky-header" v-for="month in months" :key="month" style="min-width: 80px;">
                            {{ month }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="stick">Сальдо на начало</td>
                        <td v-for="item in bddsBegOst" :key="item.ID" class="text-right">{{item.Val | toCurrency}}</td>
                    </tr>
                    <tr>
                        <td>
                          <v-btn icon color="default darken-1" @click="clickShow('in')" v-show="bddsIn.length>0">
                            <v-icon class="mdi-18px">{{iconExpand('in')}}</v-icon>
                          </v-btn>
                          <span class="font-weight-black">Поступления</span>
                        </td>
                        <td v-for="SummIn in In" :key="SummIn.ID" class="text-right">
                          {{ SummIn.Val | toCurrency }}
                        </td>
                    </tr>
                    <template v-for="(group, indexgr) in bddsIn">
                        <tr :key="'g'+group.ID" v-if="group.ID > 0" v-show="ShowId('in')">
                            <td class="stick">
                                <v-btn icon color="default darken-1" @click="clickShow(group.ID)" v-show="group.sub.length>0">
                                  <v-icon class="mdi-18px">{{iconExpand(group.ID)}}</v-icon>
                                </v-btn>
                                <span class="font-weight-bold">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }} {{ group.Name }}</span>
                            </td>
                            <td v-for="SummGroup in group.Sums" :key="SummGroup.ID" class="text-right">
                              {{ SummGroup.Val | toCurrency }}
                            </td>
                        </tr>
                        <template v-for="(item, indexs) in group.sub">
                            <tr :key="'s'+item.ID" v-show="ShowId(group.ID) && ShowId('in')">
                                <td class="stick">
                                    <v-btn icon color="default darken-1" @click="clickShow(item.ID)" v-show="item.sub.length>0">
                                      <v-icon class="mdi-18px">{{iconExpand(item.ID)}}</v-icon>
                                    </v-btn>
                                    <v-btn v-show="isEditShow(item.IdHouse) && !(item.sub.length>0)" icon color="default darken-1" @click="editClick(item.ID, item.Name, item.Summ, item.UseLimit, item.limitsum)" :data-id="item.ID">
                                        <v-icon class="mdi-18px">mdi-pencil</v-icon>
                                    </v-btn>
                                    <span class="pl-2 font-weight-medium">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }} {{ item.Name }}</span>
                                </td>
                                <td v-for="Summ in item.Sums" :key="Summ.ID" class="text-right">
                                    {{ Summ.Val | toCurrency }}
                                </td>
                            </tr>
                            <tr v-for="(subitem, indexsub) in item.sub" :key="'s'+item.ID+'s'+subitem.ID" v-show="ShowId(item.ID) && ShowId(group.ID) && ShowId('in')">
                                <td class="stick">
                                    <v-btn class="ml-14" v-show="isEditShow(subitem.IdHouse)" icon color="default darken-1" @click="editClick(subitem.ID, subitem.Name, subitem.Summ, item.UseLimit, subitem.limitsum)" :data-id="subitem.ID">
                                        <v-icon class="mdi-18px">mdi-pencil</v-icon>
                                    </v-btn>
                                    <span class="pl-2">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }}.{{ subitem.Numb>0 ? subitem.Numb : indexsub + 1 }} {{ subitem.Name }}</span>
                                </td>
                                <td v-for="Summsub in subitem.Sums" :key="Summsub.ID" class="text-right">
                                    {{ Summsub.Val | toCurrency }}
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tr>
                        <td>
                          <v-btn icon color="default darken-1" @click="clickShow('out')" v-show="bddsOut.length>0">
                            <v-icon class="mdi-18px">{{iconExpand('out')}}</v-icon>
                          </v-btn>
                          <span class="font-weight-black">Расходы</span>
                        </td>
                        <td v-for="SummOut in Out" :key="SummOut.ID" class="text-right">
                          {{ SummOut.Val | toCurrency }}
                        </td>
                    </tr>
                    <template v-for="(group, indexgr) in bddsOut">
                        <tr :key="'g'+group.ID" v-if="group.ID > 0" v-show="ShowId('out')">
                            <td class="stick">
                                <v-btn icon color="default darken-1" @click="clickShow(group.ID)" v-show="group.sub.length>0">
                                  <v-icon class="mdi-18px">{{iconExpand(group.ID)}}</v-icon>
                                </v-btn>
                                <span class="font-weight-bold">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }} {{ group.Name }}</span>
                                <v-btn icon color="default darken-1" @click="editStaii(group.ID)" :data-id="'set'+group.ID" v-show="group.Type == 1">
                                    <v-icon class="mdi-18px">mdi-cog</v-icon>
                                </v-btn>
                            </td>
                            <td v-for="SummGroup in group.Sums" :key="SummGroup.ID" class="text-right">
                              {{ SummGroup.Val | toCurrency }}
                            </td>
                        </tr>
                        <template v-for="(item, indexs) in group.sub">
                            <tr :key="'s'+item.ID" v-show="ShowId(group.ID) && ShowId('out')">
                                <td class="stick">
                                    <v-btn icon color="default darken-1" @click="clickShow(item.ID)" v-show="item.sub.length>0">
                                      <v-icon class="mdi-18px">{{iconExpand(item.ID)}}</v-icon>
                                    </v-btn>
                                    <v-btn v-show="isEditShow(item.IdHouse) && !(item.sub.length>0)" icon color="default darken-1" @click="editClick(item.ID, item.Name, item.Summ, item.UseLimit, item.limitsum)" :data-id="item.ID">
                                        <v-icon class="mdi-18px">mdi-pencil</v-icon>
                                    </v-btn>
                                    <span class="pl-2 font-weight-medium">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }} {{ item.Name }}</span>
                                    <v-btn icon color="default darken-1" @click="editStaii(item.ID)" :data-id="'set'+item.ID">
                                        <v-icon class="mdi-18px">mdi-cog</v-icon>
                                    </v-btn>
                                </td>
                                <td v-for="Summ in item.Sums" :key="Summ.ID" class="text-right">
                                    {{ Summ.Val | toCurrency }}
                                </td>
                            </tr>
                            <tr v-for="(subitem, indexsub) in item.sub" :key="'s'+item.ID+'s'+subitem.ID" v-show="ShowId(item.ID) && ShowId(group.ID) && ShowId('out')">
                                <td class="stick">
                                    <v-btn class="ml-14" v-show="isEditShow(subitem.IdHouse)" icon color="default darken-1" @click="editClick(subitem.ID, subitem.Name, subitem.Summ, item.UseLimit, subitem.limitsum)" :data-id="subitem.ID">
                                        <v-icon class="mdi-18px">mdi-pencil</v-icon>
                                    </v-btn>
                                    <span class="pl-2">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }}.{{ subitem.Numb>0 ? subitem.Numb : indexsub + 1 }} {{ subitem.Name }}</span>
                                    <v-btn icon color="default darken-1" @click="editStaii(subitem.ID)" :data-id="'set'+item.ID">
                                        <v-icon class="mdi-18px">mdi-cog</v-icon>
                                    </v-btn>
                                </td>
                                <td v-for="Summsub in subitem.Sums" :key="Summsub.ID" class="text-right">
                                    {{ Summsub.Val | toCurrency }}
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tr>
                        <td class="stick">Сальдо на конец</td>
                        <td v-for="item in bddsEndOst" :key="item.ID" :class="'text-right ' + endColor(item.Val)">{{item.Val | toCurrency}}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
        </v-skeleton-loader>
        <v-dialog v-model="dialog" max-width="640">
            <v-card>
                <v-card-title class="headline">Cумма статьи</v-card-title>
                <v-card-text>
                    <div class="pb-3">{{editname}}</div>
                    <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                            v-on:submit.prevent="saveSumSatia"
                    >
                      <v-row>
                        <v-col cols="6">
                          <v-select
                              v-model="monthFirst"
                              :items="monthItem"
                              label="Период с"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <v-select
                              v-model="monthLast"
                              :items="monthItem"
                              label="Период по"
                          ></v-select>
                        </v-col>
                      </v-row>

                        <v-text-field
                                v-model="Summ"
                                :counter="10"
                                :rules="summaRules"
                                label="Сумма"
                                @click="clickSumm"
                                required
                        ></v-text-field>
                        <div v-show="UseLimit">Лимит: {{limitsum | toCurrency}}</div>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="gray darken-1" text @click="dialog = false">
                        Отмена
                    </v-btn>

                    <v-btn color="green darken-1" text @click="saveSumSatia">
                        Сохранить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js';

    export default {
        name: "BddsPlan",
        mounted() {
            this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                this.$store.dispatch('GET_BDDSPLANLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse, IsTarif: this.switchTarif}).then(() => {
                    this.loading = false;
                });
            });

            bus.$on('refreshTabBddsPlan', this.refreshHandler);
            bus.$on('resetFilterhTabBddsPlan', this.resetFilterh);
        },
        beforeMount () {
            this.loadFilters();
        },
        data() {
            return {
                loading: true,
                yearbdds: new Date().getFullYear(),
                IdOrg: localStorage.getItem('idtsg'),
                IdHouse: '',
                monthbdds: [],
                monthbddsGet: '',
                monthsFilter: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                monthItem: [
                  {value: 1, text: 'Январь'},
                  {value: 2, text: 'Февраль'},
                  {value: 3, text: 'Март'},
                  {value: 4, text: 'Апрель'},
                  {value: 5, text: 'Май'},
                  {value: 6, text: 'Июнь'},
                  {value: 7, text: 'Июль'},
                  {value: 8, text: 'Август'},
                  {value: 9, text: 'Сентябрь'},
                  {value: 10, text: 'Октябрь'},
                  {value: 11, text: 'Ноябрь'},
                  {value: 12, text: 'Декабрь'},
                ],
                dialog: false,
                editid: 0,
                editname: 0,
                valid: true,
                Summ: 0,
                limitsum: 0,
                UseLimit: false,
                switchTarif: false,
                heightTable: (window.innerHeight - 200),
                monthFirst:1,
                monthLast:12,
                expand: [{expand: false, ID: 'in'}],
                expandOut: [{expand: false, ID: 'out'}],
            }
        },
        methods: {
          log(item){
            console.log(item);
          },
            loadFilters: function() {
                let year = localStorage.getItem('VUE_TABS_BDDSPLAN_YEAR');
                if (year) {
                    this.IdOrg = JSON.parse(year);
                }
                /*let month = localStorage.getItem('VUE_TABS_BDDSPLAN_MONTH');
                if (month) {
                  this.monthbdds = JSON.parse(month);
                  if(this.monthbdds.length>0){
                    this.months = [];
                    for (let hs of this.monthsFilter) {
                      if (this.monthbdds.indexOf( hs ) != -1) {
                        this.months.push(hs);
                      }
                    }
                    this.monthbddsGet = '';
                    for (let bdds of this.monthbdds) {
                      this.monthbddsGet = this.monthbddsGet+';'+bdds;
                    }
                  }
                }else{
                  this.monthbddsGet = '';
                }*/
                let org = localStorage.getItem('VUE_TABS_BDDSPLAN_ORG');
                if (org) {
                    this.IdOrg = JSON.parse(org);
                }
                let house = localStorage.getItem('VUE_TABS_BDDSPLAN_HOUSE');
                if (house) {
                    this.IdHouse = JSON.parse(house);
                }
            },
            formatCurrency(value) {
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            },
            fromCurrency(value) {
                value = value.replace(/\s/, '');
                value = value.replace(/,/, '.');
                return value;
            },
            saveFilters: function() {
                localStorage.setItem('VUE_TABS_BDDSPLAN_YEAR', JSON.stringify(this.yearbdds));
                localStorage.setItem('VUE_TABS_BDDSPLAN_MONTH', JSON.stringify(this.monthbdds));
                localStorage.setItem('VUE_TABS_BDDSPLAN_ORG', JSON.stringify(this.IdOrg));
                localStorage.setItem('VUE_TABS_BDDSPLAN_HOUSE', JSON.stringify(this.IdHouse));
                let month = localStorage.getItem('VUE_TABS_BDDSPLAN_MONTH');
                if (month) {
                  this.monthbdds = JSON.parse(month);
                  if(this.monthbdds.length>0){
                    this.months = [];
                    for (let hs of this.monthsFilter) {
                      if (this.monthbdds.indexOf( hs ) != -1) {
                        this.months.push(hs);
                      }
                    }
                    this.monthbddsGet = '';
                    for (let bdds of this.monthbdds) {
                      this.monthbddsGet = this.monthbddsGet+';'+bdds;
                    }
                  }else{
                    this.months = this.monthsFilter;
                    this.monthbddsGet = '';
                  }
                }else{
                  this.monthbddsGet = '';
                }
            },
            isEditShow(IdHouse) {
                return this.IdOrg > 0 && (IdHouse == 0 || this.IdHouse > 0);
            },
            editClick(id, name, sum, uselimit, limitsum) {
                this.editid = id;
                this.editname = name;
                this.Summ = this.formatCurrency(sum);
                this.UseLimit = uselimit == 1;
                this.limitsum = parseFloat(limitsum);
                this.dialog = true;
            },
            changeYearHandle() {
                this.saveFilters();
                this.updateClick();
            },
            changeOrg() {
                this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                    this.updateClick();
                });
                this.saveFilters();
            },
            changeHouse() {
                if (this.IdHouse > 0) {
                    if (this.$store.getters.ORGFILTERS) {
                        this.$store.getters.ORGFILTERS.houselist.forEach((item) => {
                            if (item.ID == this.IdHouse) {
                                this.IdOrg = item.IdTsj;
                                return false;
                            }
                        });
                    }
                }
                this.saveFilters();
                this.updateClick();
            },
            updateClick() {
                //this.expand = [{expand: false, ID: 'in'}];
                //this.expandOut = [{expand: false, ID: 'out'}];
                this.$store.dispatch('GET_BDDSPLANLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse, IsTarif: this.switchTarif}).then(() => {
                    if (this.IdHouse < 1) {
                        this.switchTarif = false;
                    }
                });
            },
            saveSumSatia() {

                if (this.UseLimit > 0 && (this.fromCurrency(this.Summ) > this.limitsum || this.fromCurrency(this.Summ) <= 0) || this.monthFirst > this.monthLast) {
                    return;
                }
                this.dialog = false;
                this.$store.dispatch('SAVE_BDDSPLANLIST', {
                    year: this.yearbdds,
                    IdStatii: this.editid,
                    Summ: this.fromCurrency(this.Summ),
                    IdOrg: this.IdOrg,
                    IdHouse: this.IdHouse,
                    monthFirst: this.monthFirst,
                    monthLast: this.monthLast,
                }).then(() => {
                    this.updateClick();
                });

            },
            switchTarifClick() {
                this.updateClick();
            },
            endColor(Val) {
                return Val > 0 ? "black--text" : "red--text";
            },
            refreshHandler() {
                this.onResize();
                this.updateClick();
            },
            resetFilterh(params) {
                this.IdOrg = params.IdOrg;
                this.IdHouse = params.IdHouse;
                this.updateClick();
            },
            addStaii() {
                this.$parent.addTab('Добавить статью объекту', 0, 'BddsAddStatii', {id: 0, IdOrgDef: this.IdOrg, IdHouseDef: this.IdHouse});
            },
            editStaii(id) {
                this.$parent.addTab('Изменить статью объекта ' + id, id, 'BddsAddStatii', {id: id, IdOrgDef: this.IdOrg, IdHouseDef: this.IdHouse});
            },
            onResize() {
                //this.heightTable = (window.innerHeight - this.$refs.bddsplancontainer.clientHeight - 125);
            },
            excelPlanList(){
              this.$store.dispatch('EXCEL_BDDSPLANLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse}).then(response => {
                window.open(response.data);
              });
            },
            clickSumm(){
                if(this.Summ == 0)
                  this.Summ='';
            },
            ShowId(id){
              let ret = false;
              this.expand.forEach((item) => {
                if(item.ID == id)
                  ret = item.expand;
              });
              this.expandOut.forEach((item) => {
                if(item.ID == id)
                  ret = item.expand;
              });
              return ret;
            },
            clickShow(id){
              this.expand.forEach((item) => {
                if(item.ID == id){
                  if(item.expand)
                    item.expand = false;
                  else
                    item.expand = true;
                }
              });
              this.expandOut.forEach((item) => {
                if(item.ID == id){
                  if(item.expand)
                    item.expand = false;
                  else
                    item.expand = true;
                }
              });
            },
            iconExpand(id){
              let ret = 'mdi-plus-box-outline';
              this.expand.forEach((item) => {
                if(item.ID == id && item.expand)
                  ret = 'mdi-minus-box-outline';
              });
              this.expandOut.forEach((item) => {
                if(item.ID == id && item.expand)
                  ret = 'mdi-minus-box-outline';
              });
              return ret;
            },

        },
        computed: {
            summaRules() {
                const limitsum = parseFloat(this.limitsum);
                const UseLimit = this.UseLimit;
                const rules = [];
                let rule = v => !!v || 'Введите сумму';
                rules.push(rule);
                rule = v => (v && v.length <= 10) || 'Сумма не более 10 символов';
                rules.push(rule);
                if (UseLimit) {
                    rule = v => (this.fromCurrency(v) <= limitsum) || 'Сумма превышает лимит';
                    rules.push(rule);
                }
                return rules;
            },
            yearfilter() {
                let nowYear = new Date().getFullYear() + 1;
                let years = [];
                for (let i = 0; i < 5; i++) {
                    years.push(nowYear - i);
                }
                return years;
            },
            bddsIn() {
              if(this.$store.getters.BDDSPLANLIST){
                  this.$store.getters.BDDSPLANLIST.datain.forEach((item) => {
                    let exp = true;
                    for (let Out of this.expand){
                      if(Out.ID == item.ID)
                        exp = false;
                    }
                    if(exp)
                      this.expand.push({expand: false, ID: item.ID});
                    if(item.sub.length>0){
                      item.sub.forEach((sub) => {
                        let exp = true;
                        for (let Out of this.expand){
                          if(Out.ID == sub.ID)
                            exp = false;
                        }
                        if(exp)
                          this.expand.push({expand: false, ID: sub.ID});
                      });
                    }
                  });
              }
              return this.$store.getters.BDDSPLANLIST ? this.$store.getters.BDDSPLANLIST.datain : [];
            },
            bddsOut() {
              if(this.$store.getters.BDDSPLANLIST){
                  this.$store.getters.BDDSPLANLIST.dataout.forEach((item) => {
                    let exp = true;
                    for (let Out of this.expandOut){
                      if(Out.ID == item.ID)
                        exp = false;
                    }
                    if(exp)
                      this.expandOut.push({expand: false, ID: item.ID});
                    if (item.sub.length > 0) {
                      item.sub.forEach((sub) => {
                        let exp = true;
                        for (let Out of this.expandOut){
                          if(Out.ID == sub.ID)
                            exp = false;
                        }
                        if(exp)
                          this.expandOut.push({expand: false, ID: sub.ID});
                      });
                    }
                  });
              }
              return this.$store.getters.BDDSPLANLIST ? this.$store.getters.BDDSPLANLIST.dataout : [];
            },
            In() {
              return this.$store.getters.BDDSPLANLIST ? this.$store.getters.BDDSPLANLIST.arIn : [];
            },
            Out() {
              return this.$store.getters.BDDSPLANLIST ? this.$store.getters.BDDSPLANLIST.arOut : [];
            },
            bddsBegOst() {
                return this.$store.getters.BDDSPLANLIST ? this.$store.getters.BDDSPLANLIST.databegost : [];
            },
            bddsEndOst() {
                return this.$store.getters.BDDSPLANLIST ? this.$store.getters.BDDSPLANLIST.dataendost : [];
            },
            houselist() {
                let ret = [{text: 'Все', value: -1}];
                if (this.$store.getters.ORGFILTERS) {
                    this.$store.getters.ORGFILTERS.houselist.forEach((item) => {
                        if (this.IdOrg == '' || (this.IdOrg > 0 && item.IdTsj == this.IdOrg)) {
                            ret.push({text: item.Name, value: item.ID});
                        }
                    });
                }
                return ret;
            },
            orglist() {
                let ret = [];
                if (this.$store.getters.ORGFILTERS) {
                  if(localStorage.getItem('idtsg')>0){
                    this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                      if(item.ID == localStorage.getItem('idtsg'))
                        ret.push({text: item.Name, value: item.ID});
                    });
                  }else{
                    this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                      ret.push({text: item.Name, value: item.ID});
                    });
                  }

                }
                return ret;
            }
        },
        filters: {
            toCurrency: function (value) {
                if (value === undefined) value = 0;
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            }
        },
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 35px;
    }
    .v-data-table /deep/ .sticky-header {
      position: sticky;
      top: 126px;
      z-index: 1;
      background: #fff;
    }
    .v-data-table /deep/ .v-data-table__wrapper {
      overflow: unset;
    }
</style>